import { auditTypes } from 'json/new-to-old-audit'
export let awardTabs = [
  {
    label: '全部列表',
    value: 'ALL'
  },
  {
    label: '待客服审核',
    // label: '待地区审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '待财务审核',
    // label: '待总部财务审核',
    value: 'SALES_COMPLETED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  // {
  //   label:"已驳回",
  //   value:"REJECTED"
  // },
  {
    label: '客服已驳回',
    // label: '地区已驳回',
    value: 'SALES_REJECTED'
  },
  {
    label: '财务已驳回',
    // label: '总部财务已驳回',
    value: 'REJECTED'
  }
  // {
  //   label: '已退款',
  //   value: 'REFUND'
  // }
]
export let awardTabsQJK = [
  {
    label: '全部列表',
    value: 'ALL'
  },
  {
    // label: '待客服审核',
    label: '待地区审核',
    value: 'WAITING_FOR_APPROVAL_FIRST'
  },
  {
    label: '待总部客服审核',
    value: 'WAITING_FOR_APPROVAL_SECOND'
  },
  {
    // label: '待财务审核',
    label: '待总部财务审核',
    value: 'SALES_COMPLETED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '已驳回',
    value: 'REJECTED_ALL'
  },
  {
    label: '已退款',
    value: 'REFUND'
  }
]
export let awardTableLabel = [
//   {
//     label: '奖励审核流水号',
//     value: 'number'
//   },
//   {
//     label: '申请ID',
//     value: ''
//   },
//   {
//     label: '申请日期',
//     value: 'extendInformation.achieve_date'
//   },
//   {
//     label: '申请类型',
//     value: 'extendInformation.user_type'
//   },
//   {
//     label: '老用户手机号',
//     value: 'extendInformation.customerBringNew.oldCustomer.userMobile'
//   },
//   {
//     label: '老用户合同姓名',
//     value: ''
//   },
//   {
//     label: '奖励金额',
//     value: 'reward_money'
//   },
//   {
//     label: '奖励优惠券',
//     value: 'couponTotalAmount'
//   },
//   {
//     label: '奖励轮次',
//     value: 'extendInformation.rewardCount'
//   },
//   {
//     label: '合同姓名',
//     value: 'extendInformation.customerBringNew.newCustomer.motherName'
//   },
//   {
//     label: 'C端手机号',
//     value: 'extendInformation.userMobile'
//   },
  // {
  //   label: '申请日期',
  //   value: 'extendInformation.achieve_date'
  // },
  // {
  //   label: '申请类型',
  //   value: 'extendInformation.user_type'
  // },
  // {
  //   label: '老用户姓名',
  //   value: 'extendInformation.customerBringNew.oldCustomer.userName'
  // },
  // {
  //   label: '',
  //   value: ''
  // },
  // {
  //   label: '',
  //   value: ''
  // }
  // {
  //   label: '用户类型',
  //   value: 'extendInformation.user_type'
  // }
  // {
  //   label: '奖励次数',
  //   value: 'extendInformation.rewardCount'
  // }
  // {
  //   label: 'CPS合同号',
  //   minWidth: 130,
  //   value: 'extendInformation.CPSNumber'
  // },
  // {
  //   label: '地区',
  //   value: 'extendInformation.cpsRegion'
  // },
  // {
  //   label: '合同签订时间',
  //   minWidth: 130,
  //   value: 'extendInformation.contract_date'
  // },
  // {
  //   label: '平台注册时间',
  //   value: 'extendInformation.register_date'
  // },
  // {
  //   label: '返现',
  //   value: 'reward_money'
  // },
  // {
  //   label: '返劵',
  //   value: 'couponTotalAmount'
  // },
  // {
  //   label: '发放时间',
  //   value: 'created_date'
  // }
//   {
//     label: '状态',
//     value: 'audit_status'
//   }
]
// 奖励列表筛选条件
export let filterLabels = [
  {
    label: '合同签订时间',
    type: 'time-slot',
    value: 'contractDate',
    clearable: true,
    startName: 'contractDateStart', // 返回数据时，开始时间的字段名
    endName: 'contractDateEnd' // 返回数据时，结束时间的字段名
  },
  {
    label: '平台注册时间',
    type: 'time-slot',
    value: 'registerDate',
    clearable: true,
    startName: 'registerDateStart', // 返回数据时，开始时间的字段名
    endName: 'registerDateEnd' // 返回数据时，结束时间的字段名
  },
  {
    label: '用户类型',
    type: 'select',
    value: 'userType',
    clearable: true,
    options: auditTypes
  },
  {
    label: '奖励次数',
    type: 'select',
    value: 'rewardCount',
    clearable: true,
    options: [
      {
        label: '首次奖励',
        value: 1
      },
      {
        label: '后继奖励',
        value: 2
      }
    ]
  }
  // {
  //   label: '活动类型',
  //   type: 'select',
  //   value: 'businessType',
  //   clearable: true,
  //   options: [
  //     {
  //       label: '脐荐康奖励',
  //       value: 'CUSTOMER_BRING_NEW_QJK'
  //     },
  //     {
  //       label: '母亲节活动奖励',
  //       value: 'CUSTOMER_BRING_NEW_MOTHERS_DAY'
  //     },
  //     {
  //       label: '老带新奖励',
  //       value: 'CUSTOMER_BRING_NEW'
  //     }
  //     // '脐荐康奖励', '母亲节活动奖励', '老带新奖励'
  //   ]
  // }
  // {
  //   label: '状态',
  //   type: 'select',
  //   value: 'status',
  //   clearable: true,
  //   options: auditStatus
  // }
]
// 审核radios
export let awardRadios = [
  {
    label: '审核通过',
    value: 'COMPLETED'
  },
  {
    label: '驳回申请',
    value: 'REJECTED'
  }
]
// 审核radios
export let awardRadiosHasRemindPay = [
  ...awardRadios
  // {
  //   label: '催费',
  //   value: 'remindPay'
  // }
]
export let awardResultTableLabel = [
  {
    label: '用户姓名',
    value: 'userName'
  },
  {
    label: '用户类型',
    value: 'user_type'
  },
  {
    label: '失败项目类型',
    value: 'reward_type'
  },
  {
    label: '项目内容描述',
    value: 'rewardDescription'
  },
  {
    label: '失败原因',
    value: 'reason'
  }
]
